const $ = jQuery.noConflict();

class TribeHoursCustom {
	init() {
		this.expandFirstLocation();
	}

	expandFirstLocation() {
		const firstAccordionItem = $('.block-accordion-item').first();
		firstAccordionItem.addClass('active');
		firstAccordionItem.find('.wp-block-button__link').addClass('active');
		firstAccordionItem.find('.block-content').removeClass('DOM-slider-hidden');
		firstAccordionItem.find('.block-content').attr('aria-hidden', 'false');
	}
}

const newTribeHoursCustom = new TribeHoursCustom();

// GLOBAL APP CONTROLLER
const controller = {
	init() {},
	loaded() {
		newTribeHoursCustom.init();
	},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};

export default controller;
